import {IterationsIcon} from '@primer/octicons-react'
import {Token, type TokenProps} from '@primer/react'

import type {Iteration} from '../../../api/columns/contracts/iteration'
import {tokenIconSize} from '../../common/avatars-token'
import {SanitizedHtml} from '../../dom/sanitized-html'

interface IterationTokenProps extends Omit<TokenProps, 'leadingVisual' | 'text'> {
  iteration: Iteration
  ref?: React.Ref<HTMLElement>
}

export const IterationToken = ({ref, iteration, ...tokenProps}: IterationTokenProps) => (
  <Token
    leadingVisual={() => <IterationsIcon size={tokenIconSize(tokenProps.size)} />}
    text={<SanitizedHtml>{iteration.titleHtml}</SanitizedHtml>}
    ref={ref}
    {...tokenProps}
  />
)
IterationToken.displayName = 'IterationToken'
